import { CoreUrlParams, FilterTypes } from 'Core/interfaces'
import { ConfigItem } from 'Core/interfaces'

import { UrlParams } from 'Portals/Customer/constants'
import {
	CustomerInvoice,
	InvoiceFilterFields,
	InvoiceMainSearchFields
} from 'Portals/Customer/entities'

export const invoiceIdSearchQuery = {
	apiFieldName: null,
	apiSearchFieldName: 'InvoiceIdQuery',
	filterType: FilterTypes.VALUE,
	UrlParam: CoreUrlParams.searchQuery
}

export const mainSearchConfig: CustomerInvoice.Search.Config = {
	[InvoiceMainSearchFields.invoiceId]: {
		label: 'Invoice ID',
		apiFieldName: InvoiceMainSearchFields.invoiceId,
		apiSearchFieldName: 'invoiceId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.id
	}
}

export const filtersConfig: CustomerInvoice.Filter.Config = {
	[InvoiceFilterFields.dateFrom]: {
		label: 'Start Invoice Date:',
		apiFilterFieldName: 'FromDate',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.startDate,
		defaultValue: null
	},
	[InvoiceFilterFields.dateTo]: {
		label: 'End Invoice Date:',
		apiFilterFieldName: 'ToDate',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.endDate,
		defaultValue: null
	},
	[InvoiceFilterFields.serviceSite]: {
		label: 'Service Site:',
		apiFilterFieldName: 'serviceSiteId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.serviceSiteId,
		defaultValue: ''
	},
	[InvoiceFilterFields.state]: {
		label: 'State:',
		apiFilterFieldName: 'StateProvinceId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.stateId,
		defaultValue: ''
	},
	[InvoiceFilterFields.includeUnpaid]: {
		label: 'Unpaid Invoices',
		filterType: FilterTypes.VALUE,
		apiFilterFieldName: 'isUnpaid',
		UrlParam: UrlParams.includeUnpaid,
		defaultValue: false
	}
}

export const searchByCityConfig: ConfigItem<null> = {
	label: 'City:',
	apiFieldName: null,
	apiSearchFieldName: 'cityName',
	filterType: FilterTypes.VALUE,
	UrlParam: UrlParams.cityName
}
